﻿<script>
	import Select from "./Select.svelte";

	export let id = "country";
	export let label;
	export let value;
	export let disabled;
	export let required;

	const countryOptionList = [
		{ name: "Australia" },
		{ name: "New Zealand" },
		{ name: "United Kingdom" },
		{ name: "Afghanistan" },
		{ name: "Albania" },
		{ name: "Algeria" },
		{ name: "American Samoa" },
		{ name: "Andorra" },
		{ name: "Angola" },
		{ name: "Anguilla" },
		{ name: "Antarctica" },
		{ name: "Antigua and Barbuda" },
		{ name: "Argentina" },
		{ name: "Armenia" },
		{ name: "Aruba" },
		{ name: "Austria" },
		{ name: "Azerbaijan" },
		{ name: "Bahamas" },
		{ name: "Bahrain" },
		{ name: "Bangladesh" },
		{ name: "Barbados" },
		{ name: "Belarus" },
		{ name: "Belgium" },
		{ name: "Belize" },
		{ name: "Benin" },
		{ name: "Bermuda" },
		{ name: "Bhutan" },
		{ name: "Bolivia" },
		{ name: "Bosnia and Herzegovina" },
		{ name: "Botswana" },
		{ name: "Bouvet Island" },
		{ name: "Brazil" },
		{ name: "British Indian Ocean Territory" },
		{ name: "Brunei" },
		{ name: "Bulgaria" },
		{ name: "Burkina Faso" },
		{ name: "Burundi" },
		{ name: "Cambodia" },
		{ name: "Cameroon" },
		{ name: "Canada" },
		{ name: "Cape Verde" },
		{ name: "Cayman Islands" },
		{ name: "Central African Republic" },
		{ name: "Chad" },
		{ name: "Chile" },
		{ name: "China" },
		{ name: "Christmas Island" },
		{ name: "Cocos (Keeling) Islands" },
		{ name: "Colombia" },
		{ name: "Comoros" },
		{ name: "Congo" },
		{ name: "Congo (DRC)" },
		{ name: "Cook Islands" },
		{ name: "Costa Rica" },
		{ name: "Côte d'Ivoire" },
		{ name: "Croatia (Hrvatska)" },
		{ name: "Cuba" },
		{ name: "Cyprus" },
		{ name: "Czech Republic" },
		{ name: "Denmark" },
		{ name: "Djibouti" },
		{ name: "Dominica" },
		{ name: "Dominican Republic" },
		{ name: "East Timor" },
		{ name: "Ecuador" },
		{ name: "Egypt" },
		{ name: "El Salvador" },
		{ name: "Equatorial Guinea" },
		{ name: "Eritrea" },
		{ name: "Estonia" },
		{ name: "Ethiopia" },
		{ name: "Falkland Islands (Islas Malvinas)" },
		{ name: "Faroe Islands" },
		{ name: "Fiji Islands" },
		{ name: "Finland" },
		{ name: "France" },
		{ name: "French Guiana" },
		{ name: "French Polynesia" },
		{ name: "French Southern and Antarctic Lands" },
		{ name: "Gabon" },
		{ name: "Gambia" },
		{ name: "Georgia" },
		{ name: "Germany" },
		{ name: "Ghana" },
		{ name: "Gibraltar" },
		{ name: "Greece" },
		{ name: "Greenland" },
		{ name: "Grenada" },
		{ name: "Guadeloupe" },
		{ name: "Guam" },
		{ name: "Guatemala" },
		{ name: "Guinea" },
		{ name: "GuineaBissau" },
		{ name: "Guyana" },
		{ name: "Haiti" },
		{ name: "Heard Island and McDonald Islands" },
		{ name: "Honduras" },
		{ name: "Hong Kong SAR" },
		{ name: "Hungary" },
		{ name: "Iceland" },
		{ name: "India" },
		{ name: "Indonesia" },
		{ name: "Iran" },
		{ name: "Iraq" },
		{ name: "Ireland" },
		{ name: "Israel" },
		{ name: "IsTurks and Caicos lands" },
		{ name: "Italy" },
		{ name: "Jamaica" },
		{ name: "Japan" },
		{ name: "Jordan" },
		{ name: "Kazakhstan" },
		{ name: "Kenya" },
		{ name: "Kiribati" },
		{ name: "Korea" },
		{ name: "Kuwait" },
		{ name: "Kyrgyzstan" },
		{ name: "Laos" },
		{ name: "Latvia" },
		{ name: "Lebanon" },
		{ name: "Lesotho" },
		{ name: "Liberia" },
		{ name: "Libya" },
		{ name: "Liechtenstein" },
		{ name: "Lithuania" },
		{ name: "Luxembourg" },
		{ name: "Macau SAR" },
		{ name: "Macedonia, Former Yugoslav Republic of" },
		{ name: "Madagascar" },
		{ name: "Malawi" },
		{ name: "Malaysia" },
		{ name: "Maldives" },
		{ name: "Mali" },
		{ name: "Malta" },
		{ name: "Marshall Islands" },
		{ name: "Martinique" },
		{ name: "Mauritania" },
		{ name: "Mauritius" },
		{ name: "Mayotte" },
		{ name: "Mexico" },
		{ name: "Micronesia" },
		{ name: "Moldova" },
		{ name: "Monaco" },
		{ name: "Mongolia" },
		{ name: "Montserrat" },
		{ name: "Morocco" },
		{ name: "Mozambique" },
		{ name: "Myanmar" },
		{ name: "Namibia" },
		{ name: "Nauru" },
		{ name: "Nepal" },
		{ name: "Netherlands" },
		{ name: "Netherlands Antilles" },
		{ name: "New Caledonia" },
		{ name: "Nicaragua" },
		{ name: "Niger" },
		{ name: "Nigeria" },
		{ name: "Niue" },
		{ name: "Norfolk Island" },
		{ name: "North Korea" },
		{ name: "Northern Ireland" },
		{ name: "Northern Mariana Islands" },
		{ name: "Norway" },
		{ name: "Oman" },
		{ name: "Pakistan" },
		{ name: "Palau" },
		{ name: "Panama" },
		{ name: "Papua New Guinea" },
		{ name: "Paraguay" },
		{ name: "Peru" },
		{ name: "Philippines" },
		{ name: "Pitcairn Islands" },
		{ name: "Poland" },
		{ name: "Portugal" },
		{ name: "Puerto Rico" },
		{ name: "Qatar" },
		{ name: "Reunion" },
		{ name: "Romania" },
		{ name: "Russia" },
		{ name: "Rwanda" },
		{ name: "Samoa" },
		{ name: "San Marino" },
		{ name: "São Tomé and Príncipe" },
		{ name: "Saudi Arabia" },
		{ name: "Senegal" },
		{ name: "Seychelles" },
		{ name: "Sierra Leone" },
		{ name: "Singapore" },
		{ name: "Slovakia" },
		{ name: "Slovenia" },
		{ name: "Solomon Islands" },
		{ name: "Somalia" },
		{ name: "South Africa" },
		{ name: "South Georgia and the South Sandwich Islands" },
		{ name: "Spain" },
		{ name: "Sri Lanka" },
		{ name: "St. Helena" },
		{ name: "St. Kitts and Nevis" },
		{ name: "St. Lucia" },
		{ name: "St. Pierre and Miquelon" },
		{ name: "St. Vincent and the Grenadines" },
		{ name: "Sudan" },
		{ name: "Suriname" },
		{ name: "Svalbard and Jan Mayen" },
		{ name: "Swaziland" },
		{ name: "Sweden" },
		{ name: "Switzerland" },
		{ name: "Syria" },
		{ name: "Taiwan" },
		{ name: "Tajikistan" },
		{ name: "Tanzania" },
		{ name: "Thailand" },
		{ name: "Togo" },
		{ name: "Tokelau" },
		{ name: "Tonga" },
		{ name: "Trinidad and Tobago" },
		{ name: "Tunisia" },
		{ name: "Turkey" },
		{ name: "Turkmenistan" },
		{ name: "Tuvalu" },
		{ name: "Uganda" },
		{ name: "Ukraine" },
		{ name: "United Arab Emirates" },
		{ name: "United States" },
		{ name: "United States Minor Outlying Islands" },
		{ name: "Uruguay" },
		{ name: "Uzbekistan" },
		{ name: "Vanuatu" },
		{ name: "Vatican" },
		{ name: "Venezuela" },
		{ name: "Virgin Islands (British)" },
		{ name: "Vietnam" },
		{ name: "Virgin Islands" },
		{ name: "Wallis and Futuna" },
		{ name: "Yemen" },
		{ name: "Yugoslavia" },
		{ name: "Zambia" },
		{ name: "Zimbabwe" }
	];
</script>

<Select
	{id}
	{label}
	{disabled}
	{required}
	bind:value
	optionList={countryOptionList}
	textProperty="name"
	valueProperty="name"
	on:change
></Select>
